/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/** @module MatchModule */

import { LocationHdrMatch } from 'object-types';

import { HostHdrMatchConfigItem }
    from 'ajs/modules/match/factories/host-hdr-match.config-item.factory';

/**
 * @description LocationHdrMatch Config Item class.
 * @author Abhinesh Gour
 */
export class LocationHdrMatchConfigItem extends HostHdrMatchConfigItem {
    constructor(args = {}) {
        const extendedArgs = {
            objectType: LocationHdrMatch,
            ...args,
        };

        super(extendedArgs);
    }
}
